import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';

const StringUtil = require('../../../../app/shared/StringUtil');
import SortableTable2 from '../table/SortableTable2';
import ProjectAnalytics from './ProjectAnalytics';

const propTypes = {
    projects: PropTypes.array,
    onProjectClick: PropTypes.func.isRequired,
    projectId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    channelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

const defaultProps = {
    projects: [],
    projectId: null
};

class ProjectListAnalyticsView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showLeftColumn: true
        };

        this.toggleShowLeftColumn = this.toggleShowLeftColumn.bind(this);
    }

    toggleShowLeftColumn(e) {
        this.setState({ showLeftColumn: !this.state.showLeftColumn });
    }

    render() {
        return (
            <Row className="main-content-nav">
                <div className="main-content col-12">
                    <Row>
                        <div
                            className="col-12 col-md-4 col-lg-3 padding-all-md"
                            style={this.state.showLeftColumn ? {} : { display: "none" }}
                        >
                            <h2
                                className="large-heading margin-bottom-lg"
                                role="button"
                                onClick={this.toggleShowLeftColumn}
                            >
                                <span className="fa fa-caret-down margin-right-sm" aria-hidden="true"/>
                                Projects
                            </h2>
                            <SortableTable2
                                classNameTable="font-size-md"
                                rows={this.props.projects}
                                selectedRowKey={parseInt(this.props.projectId, 10)}
                                onRowClick={this.props.onProjectClick}
                                defaultSort={{ key: 'name', type: 'string', asc: true }}
                                displayColumnCallbacks={{
                                    'activity_count': (num) => StringUtil.numberToLocaleString(num),
                                }}
                                columns={[
                                        {
                                            displayName: 'Name',
                                            key: 'name',
                                            type: 'string',
                                            width: '70%'
                                        },
                                        {
                                            displayName: 'Activities',
                                            key:'activity_count',
                                            type: 'int',
                                            width: '30%'
                                        }
                                    ]}
                            />
                        </div>
                        <div className={this.state.showLeftColumn ? "col-12 col-md-8 col-lg-9 padding-all-md" : "col-12 padding-all-md" }>
                            <div>
                                {(!this.state.showLeftColumn) &&
                                    <h2
                                        className="large-heading margin-bottom-lg"
                                        role="button"
                                        onClick={this.toggleShowLeftColumn}
                                    >
                                        <span className="fa fa-caret-right margin-right-sm" aria-hidden="true" />
                                        Projects
                                    </h2>
                                }
                                {(!!this.props.projectId) ?
                                    <ProjectAnalytics
                                        projectId={parseInt(this.props.projectId, 10)}
                                        channelId={parseInt(this.props.channelId, 10)}
                                    />
                                    :
                                    <h2 className="heading-md text-centered margin-top-lg">
                                        Select a project from the list
                                    </h2>
                                }
                            </div>
                        </div>
                    </Row>
                </div>
            </Row>
        );
    }
}

ProjectListAnalyticsView.propTypes = propTypes;
ProjectListAnalyticsView.defaultProps = defaultProps;

export default ProjectListAnalyticsView;